import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useStyles as useEditFormStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

const useStyles = makeStyles({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1,
  },
})

// Required fields end their floating label with " *" and optional fields end
// their section heading with "(Optional)", like the group event form.
export const requiredLabel = label => `${label} *`
export const optionalLabel = label => `${label} (Optional)`

// For inputs whose label already ends with " *". Not the `required` prop,
// which would also turn on the browser's own validation bubble.
export const REQUIRED_INPUT_PROPS = { 'aria-required': true }

// Asterisk for a heading with no floating label of its own. The text stays in
// its own element so the heading is still matched by its name.
export const RequiredMark = () => {
  const classes = useStyles()
  const editClasses = useEditFormStyles()

  return (
    <>
      <span aria-hidden="true" className={editClasses.requiredMark}>
        {' *'}
      </span>
      <span className={classes.visuallyHidden}> (required)</span>
    </>
  )
}

export const RequiredFieldsNote = () => {
  const editClasses = useEditFormStyles()

  return (
    <Typography className={editClasses.fieldHelper}>
      Fields marked with * are required.
    </Typography>
  )
}
